export enum LandingTab {
    Rewind,
    News,
    Competitions,
    Messages
}
